import React from 'react';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import { Box, Text } from '@rsos/components/capstone/base';
import LinksFromTable from '../LinksFromTable';
import LinksToTable from '../LinksToTable';

const PeerAgenciesDashboard = () => {
  return (
    <AppInnerWrapper>
      <Box>
        <Text
          color="primaryText"
          data-name="dashboard-title"
          fontWeight="bold"
          size="header"
        >
          Share and Chat
        </Text>
      </Box>
      <Box mt={20}>
        <Text color="primaryText" data-name="dashboard-subtitle" size="normal">
          You can transfer 9-1-1 incidents to any agencies listed here. Please
          note that sharing an incident doesn’t always guarantee that the peer
          agency will view the shared information.
        </Text>
      </Box>
      <LinksToTable />
      <LinksFromTable />
    </AppInnerWrapper>
  );
};

export default PeerAgenciesDashboard;
